export default "__VITE_ASSET__DUskBzg8__"